import { Directive } from '@angular/core';

@Directive({
  selector: '[caTopNavSearch]'
})
export class TopNavSearchDirective {}
